// extracted by mini-css-extract-plugin
export default {"modal":"global_modal__cIfGS","overlay":"global_overlay__VIvQ8","modalcontent":"global_modalcontent__CF467"};